import React from 'react'
import styles from './modal.module.css'

type ModalProps = {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
}

export const CustomModal = ({ isOpen, onClose, children }: ModalProps) => {
  if (!isOpen) return null

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <button onClick={onClose} className={styles.closeButton}>
          x
        </button>
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  )
}
